<template>
  <section class="drivers-form">
    <el-form
      ref="form"
      :rules="rules"
      :disabled="disabled"
      :model="formData">
      <div class="drivers-container">
        <div
          v-for="(item, index) in formData.nm_drvr_list"
          v-show="(classId == 12 && index>1)||(classId == 14 && index >1)? false: true"
          :key="index"
          class="card"
          :class="{ 'form-disabled': index > 1 }"
        >
          <div class="driver-switch">
            <v-switch
              v-model="item.open"
              @change="changeOpen(index)" />
          </div>
          <!-- disabled 遮罩 -->
          <div
            v-if="!item.open"
            class="mask"></div>
          <span class="title">Driver {{ index+1 }}</span>
          <div class="form-item">
            <span>Relationship with Policyholder</span>
            <el-form-item
              :ref="`nm_drvr_list.${index}.nm_drvr_rel`"
              :rules="rules.nm_drvr_rel"
              :prop="'nm_drvr_list.' + index + '.nm_drvr_rel'" >
              <v-select
                v-model="item.nm_drvr_rel"
                :list="relationList(index)"
                :disabled="index == 0 && policyOneDriver&&form.cust_typ!=2" />
              <!-- <v-select
                v-model="item.nm_drvr_rel"
                :list="policyOneDriver&&index==0||selectCustomerData.identity==2?relation:relation.slice(1,relation.length)" /> -->
            </el-form-item>
          </div>
          <div class="form-item">
            <span>Title</span>
            <el-form-item
              :ref="'nm_drvr_list.' + index + '.nm_drvr_title'"
              :rules="rules.nm_drvr_title"
              :prop="'nm_drvr_list.' + index + '.nm_drvr_title'" >
              <v-select
                v-model="item.nm_drvr_title"
                :list="carTitleOptions"
                :disabled="index == 0 && policyOneDriver&&form.cust_typ!=2" />
            </el-form-item>
          </div>
          <div class="form-item">
            <span>Last Name</span>
            <el-form-item
              :ref="'nm_drvr_list.' + index + '.nm_drvr_lst_nm'"
              :rules="rules.nm_drvr_lst_nm"
              :prop="'nm_drvr_list.' + index + '.nm_drvr_lst_nm'" >
              <v-input
                v-model="item.nm_drvr_lst_nm"
                uppercase
                :disabled="index == 0 && policyOneDriver&&form.cust_typ!=2" />
            </el-form-item>
          </div>
          <div class="form-item">
            <span>First Name</span>
            <el-form-item
              :ref="'nm_drvr_list.' + index + '.nm_drvr_fst_nm'"
              :rules="rules.nm_drvr_fst_nm"
              :prop="'nm_drvr_list.' + index + '.nm_drvr_fst_nm'" >
              <v-input
                v-model="item.nm_drvr_fst_nm"
                uppercase
                :disabled="index == 0 && policyOneDriver&&form.cust_typ!=2" />
            </el-form-item>
          </div>
          <div class="form-item">
            <span>Date of Birth</span>
            <el-form-item
              :ref="'nm_drvr_list.' + index + '.nm_drvr_dob'"
              :rules="rules.nm_drvr_dob"
              :prop="'nm_drvr_list.' + index + '.nm_drvr_dob'" >
              <v-birth-day
                v-model="item.nm_drvr_dob"
                :disabled="index == 0 && policyOneDriver&&form.cust_typ!=2" />
            </el-form-item>
          </div>
          <div class="form-item">
            <span>HKID/Passport Number</span>
            <el-form-item
              :ref="'nm_drvr_list.' + index + '.nm_drvr_id_type'"
              :rules="rules.nm_drvr_id_type"
              :prop="'nm_drvr_list.' + index + '.nm_drvr_id_type'" >
              <v-radio-group
                v-model="item.nm_drvr_id_type"
                :list="personalIdTypOptions"
                :disabled="index == 0 && policyOneDriver&&form.cust_typ!=2" />
            </el-form-item>
            <el-form-item
              :ref="'nm_drvr_list.' + index + '.nm_drvr_id_no'"
              :rules="rules.nm_drvr_id_no"
              :prop="'nm_drvr_list.' + index + '.nm_drvr_id_no'" >
              <v-input
                v-model="item.nm_drvr_id_no"
                class="mg-t-5"
                uppercase
                :placeholder="item.nm_drvr_id_type==1?'A123456(3), please input A1234563':''"
                :disabled="index == 0 && policyOneDriver&&form.cust_typ!=2" />
            </el-form-item>
          </div>
          <div class="form-item">
            <span>Occupation</span>
            <el-form-item
              :ref="'nm_drvr_list.' + index + '.nm_drvr_occ_id'"
              :rules="rules.nm_drvr_occ_id"
              :prop="'nm_drvr_list.' + index + '.nm_drvr_occ_id'" >
              <v-select
                v-model="item.nm_drvr_occ_id"
                :list="occList"/>
            </el-form-item>
          </div>
          <div class="form-item">
            <span>Driving Experience</span>
            <el-form-item
              :ref="'nm_drvr_list.' + index + '.nm_drvr_exp'"
              :rules="rules.nm_drvr_exp"
              :prop="'nm_drvr_list.' + index + '.nm_drvr_exp'" >
              <v-select
                v-model="item.nm_drvr_exp"
                :list="drvr_exp_list" />
            </el-form-item>
          </div>
          <div
            v-if="form.no_dr_acci_ind==0"
            class="form-item">
            <span>Number of accident in last 3 years</span>
            <el-form-item
              :ref="'nm_drvr_list.' + index + '.nm_drvr_acc'"
              :prop="'nm_drvr_list.' + index + '.nm_drvr_acc'"
              :rules="rules.nm_drvr_acc">
              <v-select
                v-model="item.nm_drvr_acc"
                :list="allOptions.accident_num" />
            </el-form-item>
          </div>
          <div
            v-if="form.no_dr_deduct_ind==0"
            class="form-item">
            <span v-if="classId==11">Number of driving offence point in last 3 years</span>
            <span v-else>Number of driving offence point in last 3 years</span>
            <el-form-item
              :ref="'nm_drvr_list.' + index + '.nm_drvr_pt'"
              :prop="'nm_drvr_list.' + index + '.nm_drvr_pt'"
              :rules="rules.nm_drvr_pt">
              <v-select
                v-model="item.nm_drvr_pt"
                :list="allOptions.off_points" />
            </el-form-item>
          </div>
          <!--
          <div class="form-item">
            <span>HKID Card File</span>
            <file-container
              v-if="item.nm_drvr_id_type_pic_url"
              :fileData="{
                url: item.nm_drvr_id_type_pic_url,
                client_name:item.nm_drvr_id_type_pic_client_name
              }" />
            <el-form-item
              :ref="'nm_drvr_list.' + index + '.nm_drvr_id_type_pic_path_id'"
              :rules="rules.nm_drvr_id_type_pic_path_id"
              :prop="'nm_drvr_list.' + index + '.nm_drvr_id_type_pic_path_id'">
              <v-upload
                :otherData="{
                  index,
                  idKey: 'nm_drvr_id_type_pic_path_id',
                  nameKey: 'nm_drvr_id_type_pic_path',
                  urlKey: 'nm_drvr_id_type_pic_url',
                  client_name:'client_name'
                }"
                @uploadSuccess="handlerUploadSuccess"
              />
            </el-form-item>
          </div>
          <div class="form-item">
            <span>Driving Licence File</span>
            <file-container
              v-if="item.nm_drvr_licence_pic_url"
              :fileData="{
                url: item.nm_drvr_licence_pic_url,
                client_name:item.nm_drvr_licence_pic_client_name
              }" />
            <el-form-item
              :ref="'nm_drvr_list.' + index + '.nm_drvr_licence_pic_path_id'"
              :rules="rules.nm_drvr_licence_pic_path_id"
              :prop="'nm_drvr_list.' + index + '.nm_drvr_licence_pic_path_id'">
              <v-upload
                :otherData="{
                  index,
                  idKey: 'nm_drvr_licence_pic_path_id',
                  nameKey: 'nm_drvr_licence_pic_path',
                  urlKey: 'nm_drvr_licence_pic_url',
                  client_name:'client_name'
                }"
                @uploadSuccess="handlerUploadSuccess"
              />
            </el-form-item>
          </div>
          -->
        </div>
      </div>
    </el-form>
  </section>
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
import IDCheck from '@/utils/idcheck'
// import { uploadOrderFile } from '@/api/order'
// import FileContainer from '@/views/components/file-container'
import {mapState} from 'vuex'

export default {
  name: 'DriversForm',
  components: {
    // FileContainer
  },
  mixins: [MixinOptions, MixinRules],
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    orderId: {
      type: [String, Number],
      default: ''
    },
    formDataLock: {
      type: Number,
      default: 0
    },
    policyOneDriver: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const checkIdNo = (rule, value, callback) => {
      const index = rule.field.split('.')[1]
      let {nm_drvr_id_type,nm_drvr_id_no,open} = this.formData.nm_drvr_list[index]
      if(open)
      {
        if( value&&!IDCheck(nm_drvr_id_no)&&nm_drvr_id_type==1) {
          callback(new Error('請輸入正確的身份證號碼'))
        }
        if(!nm_drvr_id_no&&nm_drvr_id_type!=1)
        {
          callback(new Error('Please input'))
        }
      }
      callback()
    }
    const driverObj = {
      open: false,
      nm_drvr_rel: '',
      // nm_drvr_sex: '',
      nm_drvr_title: '',
      nm_drvr_lst_nm: '',
      nm_drvr_fst_nm: '',
      nm_drvr_dob: '',
      nm_drvr_id_type: '',
      nm_drvr_id_no: '',
      nm_drvr_occ_id: '',
      nm_drvr_exp: '',
      nm_drvr_id_type_pic_path: '',
      nm_drvr_id_type_pic_url: '',
      nm_drvr_id_type_pic_path_id: '',
      nm_drvr_licence_pic_path: '',
      nm_drvr_licence_pic_path_id: '',
      nm_drvr_licence_pic_url: '',
      nm_drvr_pt:'',
      nm_drvr_acc:''
    }
    const driverFileObj = {
      licence: null,
      idType: null
    }
    const checkOpen = (rule, value, callback) => {
      const index = rule.field.split('.')[1]
      const { open } = this.formData.nm_drvr_list[index]

      if(open) {
        const valueResult = value !== null && value !== ''
        const { field } = rule
        const require = this.isRequired && this.requireValid

        if(require && !valueResult) {
          callback(new Error(this.$t('placeholder.input')))
        }
        if(this.baseField.includes(field) && !valueResult) {
          callback(new Error(this.$t('placeholder.input')))
        }
        callback()
      }
      callback()
    }
    return {
      driverObj,
      driverFileObj,
      formData: {
        nm_drvr_list: [
          {
            ...driverObj
          },
          {
            ...driverObj
          },
          {
            ...driverObj
          },
          {
            ...driverObj
          }
        ]
      },
      init: false, // 標記是否已經初始化過
      rules: {
        nm_drvr_rel: [
          { validator: checkOpen, trigger: ['change', 'blur'] }
        ],
        nm_drvr_title: [
          { validator: checkOpen, trigger: ['change', 'blur'] }
        ],
        nm_drvr_lst_nm: [
          { validator: checkOpen, trigger: ['change', 'blur'] }
        ],
        nm_drvr_fst_nm: [
          { validator: checkOpen, trigger: ['change', 'blur'] }
        ],
        nm_drvr_dob: [
          { validator: checkOpen, trigger: ['change', 'blur'] }
        ],
        nm_drvr_id_type: [
          { validator: checkOpen, trigger: ['change', 'blur'] }
        ],
        nm_drvr_id_no: [
          { validator: checkIdNo, trigger: ['change', 'blur'] }
        ],
        nm_drvr_occ_id: [
          { validator: checkOpen, trigger: ['change', 'blur'] }
        ],
        nm_drvr_exp: [
          { validator: checkOpen, trigger: ['change', 'blur'] }
        ],
        nm_drvr_pt: [
          { validator: checkOpen, trigger: ['change', 'blur'] }
        ],
        nm_drvr_acc: [
          { validator: checkOpen, trigger: ['change', 'blur'] }
        ],
        id_no: [
          { validator: checkIdNo, trigger: ['change', 'blur'] }
        ],
        // nm_drvr_id_type_pic_path_id: [
        //   // { validator: checkOpen }
        // ],
        // nm_drvr_licence_pic_path_id: [
        //   // { validator: checkOpen }
        // ],
      },
      oldFormDataLock: -1,
      relation: [],
      allRelation: [],
      isSelf:0
    }
  },
  computed: {
    ...mapState('account', ['selectCustomerData']),
    // relation() {
    //   // let type = this.form.cust_typ
    //   // const result = this.allOptions.relation.filter(item => {
    //   //   item.type == type
    //   // })
    //   // debugger
    //   debugger
    //   if(!this.form.cust_typ) {
    //     debugger
    //     return []
    //   }
    //   debugger
    //   return this.allOptions.relation.filter(item => {
    //     return item.type == this.form.cust_typ
    //   })
    // }
    otherRelation() {
      return this.relation.filter(item => {
        item.is_insured != 1
      })
    },
    relationList() {
      return index=>{
        const data = this.allRelation||[]
        const other =  data.filter(item => item.is_insured != 1)
        if(index==0 && this.policyOneDriver){
          return data
        }else{
          return  other
        }
      }
    },
    classId() {
      return Number(this.form.class_id)
    },
    driversOpenStatus() {
      return this.formData.nm_drvr_list.reduce((result, item) => {
        result.push(item.open)
        return result
      }, [])
    },
    driverExpList(){
      // return (classId)=>{
      if (this.classId==14)
        return this.allOptions.drvr_exp||[]
      else
        return this['allOptions'+this.classId].drvr_exp||[]
      // }
    },
    drvr_exp_list(){
      let drvr_list = []
      let class_id = this.classId
      if (this.classId==14)
        return this.allOptions.drvr_exp||[]
      else
      {
        drvr_list =  (this['allOptions'+class_id] && this['allOptions'+class_id].drvr_exp)||[]
        drvr_list = drvr_list.filter(item=>item.is_show==1)
        return drvr_list
      }
    },
    occList(){
      let {usage_ind} = this.form||{}
      let arr = this.allOptions.occupation||[]
      if(usage_ind==2&&this.classId==14){
        arr = arr.filter(item=>item.is_mc_comm_use==1)
      }
      return  arr
    },
  },
  watch: {
    // 表單鎖，外層會更新，數值變化了才可以更新 formData
    formDataLock: {
      handler(val, old = -1) {
        if(val !== old) {
          this.oldFormDataLock = old
        }
      }
    },
    // 'form.cust_typ': {
    //   deep: true,
    //   immediate: true,
    //   handler(val) {
    //     debugger
    //     if(val) {
    //       this.relation =  this.allOptions.relation.filter(item => {
    //         return item.type == val
    //       })
    //     }
    //   }
    // },
    form: {
      deep: true,
      immediate: true,
      handler(val, old) {
        if(val.cust_typ) {
          const { company, person } = this.allOptions.relationship

          this.allRelation = val.cust_typ == 1? person: company
          // this.handlerRelOptions()
        }
        if(this.formDataLock !== this.oldFormDataLock) {
          // 觸發更新就賦值，避免二次更新
          this.oldFormDataLock = this.formDataLock
          // if(this.allRelation.length == 0) {
          //   // this.relation =  this.allOptions.relation.filter(item => {
          //   //   return item.type == val.cust_typ
          //   // })
          //   const { company, person } = this.allOptions.relationship

          //   this.allRelation = val.cust_typ == 1? person: company
          // }


          // // 只需要初始化第一次
          // if(this.init) {
          //   return
          // }
          this.handlerForm(val, old)
        }
      }
    },
    policyOneDriver: {
      immediate: true,
      handler(status) {
        let  {cust_typ} = this.form
        // let that = this
        if(status&&cust_typ!=2) {
          // this.relation = this.allRelation
          setTimeout(() => {
            this.formData.nm_drvr_list[0].nm_drvr_rel = 1
          },500)
        }
        else {
          // this.relation = this.allRelation.filter(item => {
          //   return item.is_insured != 1
          // })
        }
        // this.handlerRelOptions()
      }
    },
    // driversOpenStatus: {
    //   immediate: true,
    //   deep: true,
    //   handler(list) {
    //     if(list) {
    //       // const result = list.filter(item => item.open)
    //       this.$emit('open-driver', this.formData.nm_drvr_list, list)
    //     }
    //   }
    // }
    'formData.nm_drvr_list': {
      immediate: true,
      deep: true,
      handler(list) {
        if(list) {
          this.$emit('open-driver', list)
        }
      }
    }
  },
  created() {
    this.formData.nm_drvr_list[0].open = true
    this.changeOpen(0)
    this.init = false
  },
  methods: {
    handlerRelOptions() {
      if(this.policyOneDriver) {
        this.relation = this.allRelation
      }
      else {
        this.relation = this.allRelation.filter(item => {
          return item.is_insured != 1
        })
      }
    },
    submitForm(formName) {
      this.$refs.form.validate((valid, rules) => {
        if(valid) {
          //
          const nm_drvr_list = this.formData.nm_drvr_list.filter(item => item.open)
          this.init = true
          this.$emit('getFormData', formName, {
            no_of_nm_drvr: nm_drvr_list.length,
            nm_drvr_list
          })
        }
        else {
          // console.log(rules, '======')
          this.scrollToValidDom(rules)
        }
      })

    },
    getSaveSubmitForm(formName){
      const nm_drvr_list = this.formData.nm_drvr_list.filter(item => item.open)
      this.init = true
      this.$emit('getFormData', formName, {
        no_of_nm_drvr: nm_drvr_list.length,
        nm_drvr_list
      })
    },
    handlerUploadSuccess({ data, result, otherData }) {
      const { idKey, nameKey, urlKey, index } = otherData
      const { id,client_name, name, url } = data

      this.formData.nm_drvr_list[index][idKey] = id
      this.formData.nm_drvr_list[index][nameKey] = name
      this.formData.nm_drvr_list[index][urlKey] = url
      if(idKey == 'nm_drvr_id_type_pic_path_id') {
        this.formData.nm_drvr_list[index]['nm_drvr_id_type_pic_client_name'] = client_name
      }
      else {
        this.formData.nm_drvr_list[index]['nm_drvr_licence_pic_client_name'] = client_name
      }

      // 校驗
      this.$refs['form'].clearValidate([`nm_drvr_list.${index}.${idKey}`])

      // 用於組件文件數據通信 -- 奇葩設計，兩個地方得關聯一下數據
      this.$emit('upload-file', {
        idKey,
        nameKey,
        index,
        urlKey,
        ...data,

      })
      // 關聯投保人文件
      // 判斷第一名司機是否需要關聯投保人文件
      if(index == 0 && idKey == 'nm_drvr_id_type_pic_path_id' && this.policyOneDriver) {
        this.$emit('change-policy-file', data)
      }
    },
    handlerForm(val, old) {
      const data = val.nm_drvr_list || []
      // const count = data.length? data.length: val.no_of_nm_drvr
      const count = val.no_of_nm_drvr || 1
      // const count = 2
      for(let i = 0; i < 4; i++) {
        let obj = this.formData.nm_drvr_list[i] || {}
        if(count > i) {
          if(!data[i]) {
            data[i] = { ...this.driverObj }
          }
          // this.formData.nm_drvr_list[i] = Object.assign(obj, {
          //   ...data[i],
          //   open: true
          // })
          this.$set(this.formData.nm_drvr_list, i, {
            ...obj,
            ...data[i],
            open: true
          })
        } else {
          // this.formData.nm_drvr_list[i] = Object.assign(obj, {
          //   ...this.driverObj,
          //   open: false
          // })
          this.$set(this.formData.nm_drvr_list, i, {
            ...obj,
            ...this.driverObj,
            open: false
          })
        }
      }
      this.handlerPolicyDriverInfo(val)
    },
    changeOpen(index) {
      this.$emit('changeOpenStatus', index, this.formData.nm_drvr_list[index].open)
    },
    updateOnePolicyFile(data) {
      const { client_name, name, id, url } = data
      const target = this.formData.nm_drvr_list[0]
      this.$set(target, 'nm_drvr_id_type_pic_path_id', id)
      this.$set(target, 'nm_drvr_id_type_pic_path', name)
      this.$set(target, 'nm_drvr_id_type_pic_url', url)
      this.$set(target, 'nm_drvr_id_type_pic_client_name', client_name)
    },
    deleteOnePolicyFile() {
      const target = this.formData.nm_drvr_list[0]
      this.$set(target, 'nm_drvr_id_type_pic_path_id', '')
      this.$set(target, 'nm_drvr_id_type_pic_path', '')
      this.$set(target, 'nm_drvr_id_type_pic_url', '')
      this.$set(target, 'nm_drvr_id_type_pic_client_name', '')
    },
    // 組件間傳遞上傳數據
    updateDriversFileData(data) {
      const { index, client_name,name, id, idKey, nameKey, url } = data
      this.formData.nm_drvr_list[index][idKey] = id
      this.formData.nm_drvr_list[index][nameKey] =  name
      this.formData.nm_drvr_list[index].client_name =  client_name
      if(idKey == 'nm_drvr_id_type_pic_path_id') {
        this.formData.nm_drvr_list[index].nm_drvr_id_type_pic_url = url
      } else {
        this.formData.nm_drvr_list[index].nm_drvr_licence_pic_url = url
      }

    },
    updateDeleteDriversFileData({ index, ...params }) {
      Object.keys(params).some(key => {
        this.$set(
          this.formData.nm_drvr_list[index],
          params[key],
          '')
      })
    },
    // 關聯投保人資料
    handlerPolicyDriverInfo(data) {
      const {
        id_no, id_type, isrd_dob, isrd_fst_nm, isrd_lst_nm, isrd_title, occ_id,hldr_is_drvr_ind,
        id_type_pic,cust_typ,
      } = data
      // console.log(this.formData.nm_drvr_list[0])
      // if(this.formData.nm_drvr_list[0].nm_drvr_rel) {
      //   console.log('ik???')
      //   return
      // }
      this.isSelf  =hldr_is_drvr_ind
      const { id, client_name, path, url } = id_type_pic || {}
      const { nm_drvr_rel,nm_drvr_occ_id } = this.formData.nm_drvr_list[0]
      // 避免二次觸發 form 數據更新，影響 document 組件 司機數據
      let motor_occ_id = nm_drvr_occ_id?nm_drvr_occ_id:occ_id
      if(this.classId==14){
        this.occList.filter(item=>{
          if(item.id==occ_id)
            motor_occ_id = occ_id
        })
      }
      if(hldr_is_drvr_ind == 1&&id_type!=3) {
        Object.assign(this.formData.nm_drvr_list[0], {
          nm_drvr_rel: 1,
          nm_drvr_dob: isrd_dob,
          nm_drvr_fst_nm: isrd_fst_nm,
          nm_drvr_id_no: id_no,
          nm_drvr_id_type: id_type,
          nm_drvr_lst_nm: isrd_lst_nm,
          nm_drvr_occ_id:this.classId==14? motor_occ_id:occ_id,
          nm_drvr_title: isrd_title,
          nm_drvr_id_type_pic_path_id: id,
          nm_drvr_id_type_pic_path: path,
          nm_drvr_id_type_pic_url: url,
          nm_drvr_id_type_pic_client_name: client_name
        })
        this.init = true
        // let formData = JSON.parse(JSON.stringify(this.formData))
        // this.formData = {}
        // this.formData = formData
      }

    },
  }
}
</script>
<style lang="scss" scoped>
  .drivers-form {
    .title {
      display: block;
      padding-bottom: 15px;
      color: #616266;
      font-size: 20px;
      font-weight: 500;
    }
    .form-flex {
      display: flex;
      justify-content: space-between;
      & > .form-block {
        margin-right: 15px;
        &:last-child {
          margin-right: 0;
        }
      }
    }
    .form-block {
      margin-bottom: 16px;
      & > span:first-child {
        display: block;
        padding-bottom: 5px;
        font-weight: 500;
        font-size: 14px;
        color: #616266;
      }
    }
    .drivers-container {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .card {
        position: relative;
        margin-bottom: 15px;
        width: calc(50% - 10px);
        .driver-switch {
          position: absolute;
          top: 15px;
          right: 15px;
        }
        .mask {
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
          top: 50px;
          z-index: 2;
          background: rgba(255, 255, 255, 0.7);
        }
      }
      .form-disabled {
        .form-block {
          & > span:first-child {
          }
        }
      }
    }
  }
</style>
